import * as React from 'react';

import { withExceptionCatcher } from '@/components/hoc/withExceptionCatcher';
import CareersPageLayout from '@/components/pages/static/layouts/careers/CareersPageLayout';
import DefaultStaticLayout from '@/components/pages/static/layouts/DefaultStaticLayout';
import { IComponent } from '@/types/_app';
import AboutPageLayout from '@/components/pages/static/layouts/about/AboutPageLayout';
import AdvertisePageLayout from '@/components/pages/static/layouts/advertise/AdvertisePageLayout';
import ContactUsPageLayout from '@/components/pages/static/layouts/contact-us/ContactUsPageLayout';
import type { WordpressPage } from '@/utils/functions/wordpress/fetchPages';
import WordpressPageLayout from '@/components/pages/static/layouts/WordpressPageLayout';
import { useRouter } from 'next/router';
import CircleSpinner from '@core/components/display/spinners/CircleSpinner';
import type PostType from '@research-api/utils/api/typings/PostType';
import type { Webinar } from '@/types/ArticleType';

export interface StaticPageControllerProps {
    layout: string;
    page?: WordpressPage;
    featuredResearchPost?: PostType | null;
    featuredWebinar?: Webinar | null;
}

export const StaticPageController: IComponent<any> = (props: StaticPageControllerProps) => {
    const router = useRouter();
    const leadership = [
        {
            name: 'Jason Yanowitz',
            title: 'Co-Founder',
            imageUrl: '/images/about/team/JasonYanowitz.png',
            twitterUrl: 'https://twitter.com/JasonYanowitz',
            linkedinUrl: 'https://www.linkedin.com/in/yanowitzjason/',
        },
        {
            name: 'Michael Ippolito',
            title: 'Co-Founder',
            imageUrl: '/images/about/team/MichaelIppolito.png',
            twitterUrl: 'https://twitter.com/MikeIppolito_',
            linkedinUrl: 'https://www.linkedin.com/in/michael-ippolito-b47b89105/',
        },
        {
            name: 'Julie Muroff',
            title: 'Chief Operating Officer',
            imageUrl: '/images/about/team/JulieMuroff.png',
            twitterUrl: '',
            linkedinUrl: 'https://www.linkedin.com/in/juliemuroff/',
        },
        {
            name: 'Carolyn Polke',
            title: 'Chief Strategy Officer',
            imageUrl: '/images/about/team/CarolynPolke.png',
            twitterUrl: 'https://twitter.com/carolynpolke',
            linkedinUrl: 'https://www.linkedin.com/in/carolynpolke/',
        },
        {
            name: 'Dennis Stücken',
            title: 'Chief Technology Officer',
            imageUrl: '/images/about/team/DennisStücken.png',
            twitterUrl: 'https://twitter.com/itsdennis_s',
            linkedinUrl: 'https://www.linkedin.com/in/dstuecken/',
        },
        {
            name: 'Jon Rice',
            title: 'Editor-In-Chief',
            imageUrl: '/images/about/team/JonRice.png',
            twitterUrl: 'https://twitter.com/jonricecrypto',
            linkedinUrl: 'https://www.linkedin.com/in/jonricecrypto/',
        },
    ];

    switch (props.layout) {
        case 'about':
            return <AboutPageLayout leadership={leadership} {...props} />;
        case 'careers':
            return <CareersPageLayout />;
        /*
        case 'clients':
            return (
                <ClientsPageLayout
                    header={{
                        title: "You're in good company",
                        subTitle: 'Clients',
                        description: 'Some of our trusted advertising clients below.',
                    }}
                />
            ); */
        case 'advertise':
            return <AdvertisePageLayout />;
        case 'contact-us':
            return <ContactUsPageLayout />;
        default:
            if (props.page) {
                if (router.isFallback) {
                    return (
                        <div className="flex align-center justify-center p-12">
                            <CircleSpinner />
                        </div>
                    );
                }
                return (
                    <WordpressPageLayout
                        featuredResearchPost={props.featuredResearchPost}
                        featuredWebinar={props.featuredWebinar}
                        page={props.page}
                    />
                );
            }

            return <DefaultStaticLayout {...props} />;
    }
};

export default withExceptionCatcher(StaticPageController);
